/***大图组件 */

<template>
  <div class="photoView" v-if="tag === 'photo'">
    <div class="header">
      <span class="close" @click="hidePhotoView()">收起</span>
      <span class="bigPhoto" @click="lookBigPhoto()">查看大图</span>
    </div>
    <div ref="bannerView" class="bannerView" @click="bannerViewClickEvent" @mousemove="mouseMoveEvent">
      <div class="imgBox" :style="{height:`${img_height}px`}" v-if="currentUrl">
        <img :src="imgload()" @load="setImgInfo($event.target)"/>
      </div>
    </div>
  </div>
  <div class="shadowView" v-else-if="tag === 'shadow' && shadowView.show === true " @click.self="hideShadowView()">
    <div ref="bannerView" class="bannerView" @click="bannerViewClickEvent" @mousemove="mouseMoveEvent">
      <div class="items">
        <div class="item">
          <div class="imgBox" :style="{height:`${shadowView.img_height}px`}" v-if="shadowView.currentUrl">
            <img :src="imgload()" @load="setImgInfo($event.target)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Utils} from '../../utils';

import {IMG_ARROW_LEFT, IMG_ARROW_RIGHT} from '../../assets'
var u1 = "https://static1.bcjiaoyu.com/test.jpg"
var u2 = "https://static1.bcjiaoyu.com/bcgame_face2face/13301257976/b%279e50d03c03e9d664398e3bb11b48a0b0%27_m.png-220x309"
var u3 = "https://static1.bcjiaoyu.com/bcgame_face2face/13301257976/b%271e18f9d9075d9df109daac0eca386f20%27_a.png-1920x1080"
var u4 = "https://static1.bcjiaoyu.com/test1.jpg"
export default {
  name: "PreviewPhotos",
  components: {
  },
  props:{
    tag:{
      type: String,
      default: "shadow"
    },
    data:{
      type: Array,
      default: function () { return [] }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      images:{
        left: IMG_ARROW_LEFT,
        right: IMG_ARROW_RIGHT
      },
      currentUrl: '',
      img_index: 0,
      img_width: 0,
      img_height: 0,

      shadowView:{
        show: false,
        currentUrl: '',
        data: [],
        index: 0,
        img_width: 0,
        img_height: 0
      }
    };
  },
  watch:{
    index(newValue, oldValue){
      console.log(newValue, oldValue);
      this.img_index = newValue;
      this.currentUrl = this.data[this.img_index];
    }
  },
  computed: {},
  methods: {
    ...Utils,
    imgload(){
      let url = this.currentUrl;
      if(this.tag === 'shadow'){
        url = this.shadowView.currentUrl;
      }
      url = this.getImg(url, false);
      let img = new Image()
      img.src = url;
      // console.log("图片信息1:",img.width, img.height);
      return url;
    },
    // 图片自适应高度
    setImgInfo(e){
      console.log("图片信息2:", e.width, e.height);

      if(this.tag === "shadow"){
        let height = window.innerHeight*0.7;
        let marginTop = window.innerHeight*0.15;
        let paddingBottom = 0;
        if(e.height > height){
          height = e.height;
          marginTop = 25;
          paddingBottom = 25;
        }
        this.$refs["bannerView"].style.setProperty("height", height+"px");
        this.$refs["bannerView"].style.setProperty("margin-top", marginTop+"px");
        this.$refs["bannerView"].style.setProperty("padding-bottom", paddingBottom+"px");      

        e.style.setProperty("margin-top", (height - e.height) / 2 + "px")

        this.shadowView.img_width = e.width;
        this.shadowView.img_height = e.height;
      }else{
        let height = e.height;
        this.$refs["bannerView"].style.setProperty("height", height + "px");

        this.img_width = e.width;
        this.img_height = e.height;
      }
    },
    // 鼠标滑动事件
    mouseMoveEvent(e){
      // console.log(e);
      let width = this.img_width;
      if(this.tag === 'shadow'){
        width = 700;
      }
      if(e.offsetX > width/2){
        // 鼠标显示右箭头
        this.$refs["bannerView"].style.setProperty("cursor", `url(${this.images.right}), auto`)
      }else if(e.offsetX <= width/2){
        // 鼠标显示左箭头
        this.$refs["bannerView"].style.setProperty("cursor", `url(${this.images.left}), auto`)
      }else{
        // 正常图标
        this.$refs["bannerView"].style.removeProperty("cursor");
      }
    },
    // 切换下一张图片
    bannerViewClickEvent(e){
      let width = this.img_width;
      let data = this.data;
      let index = this.img_index;
      let nextUrl = ""
  
      if(this.tag === 'shadow'){
        width = 700;
        data = this.shadowView.data;
        index = this.shadowView.index;
      }

      if(e.offsetX > width/2){
        // 鼠标显示右箭头
        if(index >= data.length - 1){
          // 已经是最后一张图片
          console.log("最后一张");
          return;
        }else{
          index += 1;
          nextUrl = data[index]
        }
      }else{
        // 鼠标显示左箭头
        if(index <= 0){
          // 已经是第一张图片了
          console.log("第一张");
          return;
        }else{
          index -= 1;
          nextUrl = data[index]
        }
      }
      
      if(this.tag === 'shadow'){
        this.shadowView.index = index;
        this.shadowView.currentUrl = nextUrl;
      }else{
        this.img_index = index;
        this.currentUrl = nextUrl;
      }
    },

    // 收起按钮点击事件
    hidePhotoView(){
      if(this.$parent.closeBigImg){
        this.$parent.closeBigImg();
      }
    },
    // 查看大图点击事件
    lookBigPhoto(){
      if(this.$parent.openShadowPhotoView){
        this.$parent.openShadowPhotoView(this.data, this.img_index);
      }
    },

    // 打开大图视图
    showShadowView(data, index=0){
      this.shadowView.data = data;
      this.shadowView.index = index;
      this.shadowView.currentUrl = data[index];
      this.shadowView.show = true;
      document.body.style.setProperty("overflow", 'hidden');
    },
    // 隐藏大图视图
    hideShadowView(){
      this.shadowView.show = false;
      document.body.style.removeProperty("overflow");
    }
  },
  created() {
    
  },
  destroyed(){
    
  },
  mounted() {
    if(this.tag === "photo"){
      this.img_index = this.index;
      this.currentUrl = this.data[this.img_index];
    }
  }
};
</script>

<style lang="less" scoped>
.shadowView{
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  position: fixed;
  overflow: auto;
  margin: 0;
  padding: 0;
  .bannerView{
  position: absolute;
  width: 70%;
  margin-left: 15%;
  width: 700px;
  margin-left: calc((100% - 700px) / 2) ;

  height: 70%;
  margin-top: 15%;

  // margin-top: 25px;
  // padding-bottom: 25px;

  .items{
    width: 100%;
    height: 100%;
    background: #0d0d0d;
    .item{
      width:100%;
      height: 100%;
      position: relative;
      text-align: center;
      overflow: hidden;
      vertical-align: middle;
      margin: 0;
      padding: 0;
      .imgBox{
        position: relative;
        display: block;
        img{
          display: block;
          opacity: 1;
          position: absolute;
          top: 50%;
          left: 50%;
          // transform: translateX(-50%);
          // transform: translateY(-50%);
          // transform: translate(-50%);
          transform: translate(-50%, -50%);
          // margin-left: -345px;
          // margin-top: -194px;
          zoom: 1;
          max-width: 100%;
        }
      }
    }
  }
}
}

.photoView{
  padding: 6px 20px 10px 70px;
  background-color: #f2f2f5;
  margin-left: -70px;
  margin-right: 0px;
  .header{
    height: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .close{
      padding: 0 10px;
      font-size: 12px;
      color: #333333;
      line-height: 10px;
      cursor: pointer;
    }
    .bigPhoto{
      padding: 0 10px;
      border-left-width: 1px;
      border-left-style: solid;
      line-height: 10px;
      font-size: 12px;
      color: #333333;
      border-color: #d9d9d9;
      cursor: pointer;
    }
    .close:hover,
    .bigPhoto:hover{
      color: #6b45e1;
    }
  }
  .bannerView{
    width: 100%;
    // height: 300px;
    .imgBox{
        position: relative;
        display: block;
        img{
          width: 100%;
        }
      }
  }
}
</style>
